import React from 'react';

const LoadingPage = ()=> (
    
    <div>
        <h1 className='homeTitle'>
            العنود
          </h1>
          
          <div className='list'>
              <div className='title2'> 
                  <h3>لعل القلب إن شطت خطاه</h3>
                  <h3>وهاج الجرح يؤذن بالْتِآمِ</h3>
              </div>
              <div className='title3'>
                <h3>غداً ألقاك .. إن ألقاك أنسى</h3>
                <h3>لهيب توجعي ولظى سقامي</h3>
              </div>
              <div className='title4'>
                <h3>فذا ظني بربي وهو حسبي</h3>
                <h3>عليه توكلي وبه اعتصامي</h3>
              </div>
              
              {/* <AnimatedBackground/> */}
          </div>
          <h4>علوم التفسير والحديث والتاريخ</h4>
          <h3> إهداء إلي المعلمة عنود غريب المطيري - نسأل الله لها الرحمه</h3>
          <br/><br/><br/><br/>
    </div>
)
export default LoadingPage;